export default function clickOnDateHeader(onZoomIn) {
  return function clickOnDateHeaderClosure({ startDate, event }) {
    const parentDiv = event.target.closest("div");
    if (parentDiv.classList.contains("zoomableDateHeader")) {
      onZoomIn({ startDate });
    }
  };
}
